import { render, staticRenderFns } from "./TruckEdit.vue?vue&type=template&id=3effe67c&scoped=true&"
import script from "./TruckEdit.vue?vue&type=script&lang=js&"
export * from "./TruckEdit.vue?vue&type=script&lang=js&"
import style0 from "./TruckEdit.vue?vue&type=style&index=0&id=3effe67c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3effe67c",
  null
  
)

export default component.exports